import { selectorFamily } from 'recoil';
import { InvoiceService } from 'api';
import getPostponeDueDateState from 'api/invoices/getPostponeDueDateState';
const getInvoiceByInvoiceNumber = selectorFamily({
  key: 'getInvoiceByInvoiceNumber',
  get: invoiceNumber => async ({
    get
  }) => {
    if (!invoiceNumber) return {};
    get(getPostponeDueDateState);
    try {
      return await InvoiceService.getInvoice({
        invoiceNumber
      });
    } catch (e) {
      console.error(`${e}: Could not fetch invoice details`);
    }
    return {};
  }
});
export default getInvoiceByInvoiceNumber;